import React, { useMemo } from 'react'

import { AccountSwitcher, AllAccountsConfig } from '@barracuda-internal/bds-core-v2'

import AccountSwitcherContainer from 'components/libs/accountSwitcher/accountSwitcherEmailProtection/layout/AccountSwitcherContainer'
import { useFormatMessage } from 'lib/localization'

const AccountSwitcherEmailProtectionAll = () => {
  const formatMessage = useFormatMessage('ess.account_switcher')

  const allAccountsConfig: AllAccountsConfig = useMemo(
    () => ({
      showAllAccounts: true,
      allAccountsText: formatMessage('all_accounts'),
      isAllAccountsSelected: true,
      onSelectAllAccounts: () => undefined
    }),
    [formatMessage]
  )

  return (
    <AccountSwitcherContainer nonClickable>
      <AccountSwitcher accounts={[]} allAccounts={allAccountsConfig} onSelectAccountCallback={() => undefined} />
    </AccountSwitcherContainer>
  )
}

export default AccountSwitcherEmailProtectionAll
